import React from "react";
import Header from '../Admin/Auth/Header';
import Footer from '../Admin/Auth/Footer';

export default function NotFound() {
    return (
        <div className='login-container'>
            <div className='w-75 d-flex flex-column justify-content-center align-items-center'>
                <Header />
                <div className="misc-box bg-white w-50 p-5 rounded">
                    <h1>Oops.</h1>
                    <h3>404, Page not found.</h3>
                </div>
                <Footer />
            </div>
        </div>
    );
}
